// Edit уник
import React from 'react';
import {
  Button, Card, Col, Form, Row, Badge,
} from 'react-bootstrap';
import { PlusLg } from 'react-bootstrap-icons';
import { makeUID } from '../../helpers';

import { floatRenderer } from '../../services/formatSvc';
import { FloatFlexibleInput } from '../common/MonetaryFloatInput';
import Required from '../Required';
import './styling.less';
import UniqueResultDocument from './UniqueResultDocument';

export default function UniqueResultCard({
  data,
  onResultChange,
  requestFileRemove,
  canEdit,
  letters,
  portfId,
}) {
  const getComplete = () => {
    if (!data.fact || !data.value) return '-';
    return `${floatRenderer((data.fact / data.value) * 100)}%`;
  };

  const handleDescrChange = ({ target }) => {
    onResultChange(data.id, 'descr', target.value);
  };

  const handleIsKeyChange = ({ target }) => {
    onResultChange(data.id, 'isKey', target.checked);
  };

  const handleFactChange = (value) => {
    onResultChange(data.id, 'fact', value);
  };

  const handleFileChange = (fileHash, field, value) => {
    const updatedFiles = data.files.map((f) =>
      (f.hash === fileHash ? { ...f, [field]: value } : f));
    onResultChange(data.id, 'files', updatedFiles);
  };

  const handleFileAdd = () => {
    const newFile = {
      id: null,
      title: undefined,
      type: 'link',
      hash: makeUID(5),
      year: data.year,
    };
    onResultChange(data.id, 'files', [...data.files, newFile]);
  };

  const handleFileRemove = async (id, hash) => {
    if (id) {
      await requestFileRemove(data.id, id);
    }
    const updatedFiles = data.files.filter((f) => f.hash !== hash);
    onResultChange(data.id, 'files', updatedFiles);
  };

  return (
    <Card className="mb-4">
      <Card.Header
        className="p-4"
        style={{ backgroundColor: cardHeaderColor }}
      />
      <Card.Body className="p-4">
        <Row className="mb-4">
          <Form.Group as={Col} md="12">
            <Form.Label style={styledLabel}>Название (план)</Form.Label>
            <Form.Control
              as="textarea"
              readOnly
              placeholder="Введите название"
              value={data.title}
            />
          </Form.Group>
        </Row>

        <Row className="mb-4">
          <Form.Group as={Col} md="12">
            <Form.Label style={styledLabel}>
              Описание фактически достигнутого результата
              {' '}
              <Required />
            </Form.Label>
            <Form.Control
              readOnly={!canEdit}
              value={data.descr}
              onChange={handleDescrChange}
              required
              as="textarea"
              rows={3}
              placeholder="Укажите информацию о достижении уникального результата"
            />
            <Form.Control.Feedback type="invalid">
              Обязательное поле
            </Form.Control.Feedback>
          </Form.Group>
        </Row>

        <Row className="mb-4">
          <Form.Group as={Col} md="6" lg="3">
            <Form.Label style={styledLabel}>Значение (план)</Form.Label>
            <Form.Control readOnly value={data.value} />
          </Form.Group>
          <Form.Group as={Col} md="6" lg="3">
            <Form.Label style={styledLabel}>
              Значение (факт)
              {' '}
              <Required />
            </Form.Label>
            <FloatFlexibleInput
              required
              value={data.fact}
              onChange={handleFactChange}
              placeholder="Введите значение"
            />
            <Form.Control.Feedback type="invalid">
              Обязательное поле
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group as={Col} md="6" lg="3">
            <Form.Label style={styledLabel}>Единицы измерения</Form.Label>
            <Form.Control readOnly value={data.unit} />
          </Form.Group>

          <Form.Group as={Col} md="4" lg="2">
            <Form.Label style={styledLabel}>% выполнения</Form.Label>
            <Form.Control readOnly value={getComplete()} />
          </Form.Group>

          <Form.Group as={Col} md="2" lg="1">
            <Form.Label style={styledLabel}>
              Ключевой
              {' '}
              <Required />
            </Form.Label>
            <Form.Check checked={data.isKey} onChange={handleIsKeyChange} />
            <Form.Control.Feedback type="invalid">
              Обязательное поле к заполнению
            </Form.Control.Feedback>
          </Form.Group>
        </Row>

        <Row className="mb-4">
          <Form.Group as={Col} md="12">
            <Form.Label style={styledLabel}>
              Мероприятие Постановления №729
            </Form.Label>
            <Form.Control
              readOnly
              as="textarea"
              rows={3}
              value={
                letters?.filter((e) => e?.code === data?.letterCode)[0]
                  ?.descr || ''
              }
            />
          </Form.Group>
        </Row>

        <Row className="mb-4">
          <Form.Group as={Col} md="12">
            <Form.Label style={styledLabel}>Тип</Form.Label>
            <Form.Control readOnly value={data.type.name} />
          </Form.Group>
        </Row>

        {true && (
          <Card className="mb-4">
            <Card.Header className="p-3">
              Подтверждающие документы
            </Card.Header>
            <Card.Body className="p-4">
              {data.files.map((f) => (
                <UniqueResultDocument
                  portfId={portfId}
                  file={f}
                  key={f.hash}
                  onFileChange={handleFileChange}
                  onFileRemove={handleFileRemove}
                  canEdit={canEdit}
                />
              ))}
            </Card.Body>
          </Card>
        )}
        {true && (
          <Button variant="outline-primary" onClick={handleFileAdd}>
            <PlusLg className="me-1 mb-1" />
            Добавить документ
          </Button>
        )}
      </Card.Body>
    </Card>
  );
}

const cardHeaderColor = '#F7F7F7';
const styledLabel = { color: '#7F7F7F', fontWeight: '600' };
